"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterIntervalCellFactory = void 0;
const react_1 = __importDefault(require("react"));
const common_types_1 = require("../../../common/common-types");
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const table_types_1 = require("../table-types");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const react_intl_1 = require("react-intl");
const table_styles_1 = require("../table-styles");
function filterIntervalCellFactory(Component) {
    return function FilterIntervalCell({ filter, disabled, state, onChangeState, }) {
        var _a;
        const classes = table_styles_1.useStyles();
        const { from, to } = (_a = state.numberFilter) !== null && _a !== void 0 ? _a : {
            from: null,
            to: null,
        };
        const handleChangeFrom = event_callback_hook_1.useEventCallback((value) => {
            onChangeState({
                ...state,
                operation: table_types_1.TableFilterOperation.AND,
                filters: constructNestedFilters(filter.filterkey, value, to),
                numberFilter: { from: value, to },
            });
        });
        const handleChangeTo = event_callback_hook_1.useEventCallback((value) => {
            onChangeState({
                ...state,
                operation: table_types_1.TableFilterOperation.AND,
                filters: constructNestedFilters(filter.filterkey, from, value),
                numberFilter: { from, to: value },
            });
        });
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: classes.filterDialogItemSubWrapper },
                react_1.default.createElement(Typography_1.default, null,
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_FILTER_CELL_INTERVAL_FROM", defaultMessage: "Od" })),
                react_1.default.createElement("div", { className: classes.filterDialogItemValueWrapper },
                    react_1.default.createElement(Component, { disabled: disabled, value: from, onChange: handleChangeFrom }))),
            react_1.default.createElement("div", { className: classes.filterDialogItemSubWrapper },
                react_1.default.createElement(Typography_1.default, null,
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_FILTER_CELL_INTERVAL_TO", defaultMessage: "Do" })),
                react_1.default.createElement("div", { className: classes.filterDialogItemValueWrapper },
                    react_1.default.createElement(Component, { disabled: disabled, value: to, onChange: handleChangeTo })))));
    };
}
exports.filterIntervalCellFactory = filterIntervalCellFactory;
function constructNestedFilters(field, from, to) {
    const fromFilter = from !== null
        ? {
            field,
            operation: common_types_1.ApiFilterOperation.GTE,
            value: from,
        }
        : undefined;
    const toFilter = to !== null
        ? {
            field: field,
            operation: common_types_1.ApiFilterOperation.LTE,
            value: to,
        }
        : undefined;
    return [fromFilter, toFilter].filter((f) => f !== undefined);
}
//# sourceMappingURL=filter-interval-cell-factory.js.map